import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./Publisher.css"

export const Publisher = () => {
  return (
        <>
        <RoutingMenu activeScreen="publisher" />
    <div className=''>

        <iframe

            src={`${config.RootUrl}/faculty/library/publishermaster/publishermaster.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
